angular
    .module('pis-tool.module', [
        'ui.router',
        'rzSlider',
        'pis-common.module',
        'segments.module',
        'offline.module',
        'pis-services.module'
    ]);

